/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-28 12:02:47
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-28 12:07:12
 * @FilePath: /unifyxp-v2-store-portal/src/components/Layouts/Header/index.tsx
 */
import React from 'react';
import css from './css.module.less';

const Header = (props) => {
  const { left, right } = props;
  return (
    <div className={css.container}>
      <div className={css.left}>{left}</div>
      <div className={css.right}>{right}</div>
    </div>
  );
};
export default Header;
